<template>
  <a
    @click="$emit('click')"
    class="aha-link"
    :class="[
      `aha-link--${variant}`,
      `aha-link--${type}-type`,
      `aha-link--${size}`,
      {
        'ml-4': hasMarginLeft,
        'mr-4': hasMarginRight,
      },
    ]"
  >
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    hasMarginLeft: {
      type: Boolean,
      default: false,
    },
    hasMarginRight: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'secondary',
    },
    variant: {
      type: String,
      default: 'base',
    },
    size: {
      type: String,
      default: 'sm',
    },
  },
}
</script>

<style lang="scss">
.aha-link {
  @apply inline-flex items-center cursor-pointer;
  &[disabled] {
    @apply cursor-default;
    &.aha-link--base {
      @apply text-base-60 hover:text-base-60;
    }
  }
}
.aha-link--secondary-type {
  &.aha-link--base {
    @apply text-base-80 hover:text-base-90 active:text-base-100;
  }

  &.aha-link--primary {
    @apply text-base-80 hover:text-primary-90 active:text-primary-100;
  }

  &.aha-link--danger {
    @apply text-base-80 hover:text-red-50 active:text-red-100;
  }
}
.aha-link--primary-type {
  &.aha-link--primary {
    @apply text-primary-90 hover:text-primary-100 active:text-primary-110;
  }
}
.aha-link--sm {
  @apply text-sm;
}
.aha-link--xs {
  @apply text-xs;
}
</style>
